export default __webpack_public_path__ + "locales/sl/ChangeUserTypeDialog.json?hash=43c3eb3fb2f174d26b9a416b954d99e8";